function ChangeEmailErrorHandler(response = {}) {
  if (!(response && response.data)) return;
  const { data = {} } = response;
  const { error = {} } = data;
  const { httpCode: statusCode = "no-code", message = "", errorCode } = error;

  if (statusCode === 422 && errorCode === "EMAIL_ALREADY_IN_USE") {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "email-em-uso",
          title: "E-mail em uso",
          message: `Já existe um cadastro com este e-mail. Escolha outro para continuar.`,
        },
      },
    };
  } else if (statusCode === 422 &&( errorCode === "INVALID_TOKEN"|| errorCode === "RMS002_INVALID_TOKEN")) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "troca-email-token-invalido",
          title: "Código inválido",
          message: `Verifique se o código informado está correto e tente novamente.`,
        },
      },
    };
  } else if (errorCode === "C2FA_LOW_RATING") {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "dados-nao-encontrados",
          title: "Dados não aprovados",
          message: "<strong>Lembre-se:</strong> você precisa informar os <strong>dados que sempre utiliza em outras plataformas</strong> como: redes sociais, bancos, compras online ou sites do governo.<br/> <br/><strong>Caso esses dados principais não tenham dado certo</strong>, direcione-se à um <a href='https://www.claro.com.br/atendimento/fale-com-a-claro' target='_blank'><strong>canal de autoatendimento</strong></a>.",
          buttons: [
            {
              "data-gtm-event-action": "clique:botao:modal",
              "data-gtm-event-category": "claro:cadastro:clear-sale",
              "data-gtm-event-label": "dados-nao-encontrados:canal-de-atendimento",
              label: "Canal de atendimento",
              className: 'mdn-Button mdn-Button--secondary Button-md',
              onClick: () => {
                window.open(
                  "https://www.claro.com.br/atendimento",
                  "_blank"
                );
              },
            },
            {
              "data-gtm-event-action": "clique:botao:modal",
              "data-gtm-event-category": "claro:cadastro:clear-sale",
              "data-gtm-event-label": "dados-nao-encontrados:tentar-novamente",
              label: "Tentar novamente",
            },
          ],
        },
      },
    };
  } else if (errorCode === "INVALID_EMAIL_DOMAIN") {
    return {
      ...data,
      warning: {
        message: "O domínio de e-mail é inválido.",
        errorCode,
      },
    };
  } else if (statusCode === 401) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "sessao-expirada",
          title: "Sessão expirada",
          message: "efetue o login novamente",
        },
      },
    };
  } else if (statusCode === 500) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "ERRO-500",
          title: "Ops",
          message: "Ocorreu um erro inesperado, tente novamente mais tarde!",
          systemError: data,
        },
      },
    };
  } else {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          errorCode,
          id: "ERRO",
          title: "Ocorreu um erro inesperado!",
          message: "Verifique sua conexão com a internet e tente novamente",
          systemError: data,
        },
      },
    };
  }
}
export default ChangeEmailErrorHandler;
